var _polygon, _rect, _rect2, _rect3, _polygon2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInfrastructure(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: 0,
    y: 0,
    width: 50,
    height: 50,
    viewBox: "0 0 67 55",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "42.8,11.6 42.8,10.4 41.2,10.4 "
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 36.2,
    width: 4.7,
    height: 5.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 10.4,
    width: 4.7,
    height: 5.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 49.4,
    y: 23.3,
    width: 4.7,
    height: 5.5
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "61.5,49.5 48.5,49.5 48.5,53.6 66,53.6 66,1 25.8,1 25.8,4 30.3,6.8 30.3,5.1 61.5,5.1 "
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.7,22L20.3,8.7L1,22.7v30.9h37.7V22z M35,49.4H24.5V30.9h-9.3v18.5H4.7v-25l15.7-10.8L35,23.7V49.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfrastructure);
export default __webpack_public_path__ + "static/media/infrastructure.8912a9a8cea287d49f070a2750fb1539.svg";
export { ForwardRef as ReactComponent };